// src/instruments/CustomInstrumentRegistry.js
// In-memory registry of user-created instruments.
// Follows the same onChange/_emit pattern as TrackManager and ClipLibrary.

let _nextCustomId = 1;

export class CustomInstrumentRegistry {
  constructor() {
    this._instruments = new Map();
    this._listeners = new Set();
  }

  onChange(fn) {
    this._listeners.add(fn);
    return () => this._listeners.delete(fn);
  }

  _emit() {
    this._listeners.forEach(fn => fn(this));
  }

  generateId() {
    return `custom-${_nextCustomId++}`;
  }

  register(def) {
    if (!def.id) def.id = this.generateId();
    this._instruments.set(def.id, { ...def });
    this._emit();
    return def.id;
  }

  unregister(id) {
    this._instruments.delete(id);
    this._emit();
  }

  get(id) {
    return this._instruments.get(id) || null;
  }

  getAll() {
    return Array.from(this._instruments.values());
  }

  get count() {
    return this._instruments.size;
  }
}
